import { CompanySegment } from '../common/company.enum'
import { IStatisticsDTO } from '../traceability/traceability.types'

export enum CompanyDocumentCategory {
  INTERNAL_DOCUMENT = 'internal_document',
  CERTIFICATE = 'certificate',
  OTHER = 'other',
}

export enum CompanyDocumentType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export interface IFarmData {
  nationalRegistry?: string
  ownerName?: string
}

export interface ICompany {
  id?: string
  isActive?: boolean
  createdAt?: Date
  updatedAt?: Date
  name?: string
  taxId: string
  segment?: CompanySegment
  email?: string
  address?: ICompanyAddress
  profile?: ICompanyProfile
  status?: string
  socialEnvironmentalRisks?: ISocialEnvironmentalRisk[]

  farmData?: IFarmData
}

export interface IBrandProvider {
  id: string
  name: string
  address: ICompanyAddress
  segment: CompanySegment
  taxId?: string
}

export interface ICompanyAddress {
  country?: string
  state?: string
  city?: string
  zipCode?: string
  district?: string
  street?: string
  number?: string
  geoCoords?: ICompanyAddressGeocoord
}

export interface IShortCompanyResponse {
  id: string
  name?: string
  address?: ICompanyAddress
  segment?: CompanySegment
}

export interface ICompanyProvidersResponse extends IShortCompanyResponse {
  taxId: string
  email: string
}

export interface ICompanyProvidersResponseDTO extends IShortCompanyResponse {
  taxId?: string
  email?: string
  level: number
  socialEnvironmentalRisks: ISocialEnvironmentalRisk[]
  status?: string
  previousItems: string[]
  nextItems?: string[]
  hasNextItems?: boolean
  hasPreviousItems?: boolean
}

export interface ISocialEnvironmentalRisk {
  id: string
  address?: ICompanyAddress
  date?: string
  description?: string
  fontRisk?: string
  summary?: string
  typeRisk?: string
  checked?: boolean
}

export interface IInternalDocument {
  id: string
  deletedAt: Date
  createdAt: Date
  updatedAt: Date
  name: string
  file: string
  extension: string
  expiration?: Date
  category: CompanyDocumentCategory
  type: CompanyDocumentType
  companyId: string
}

export interface ICompanyCreateRequest {
  name?: string
  taxId: string
  segment?: CompanySegment
  email: string
  address: ICompanyAddress
  farmData?: IFarmData
}
export interface ICompanyAddressGeocoord {
  address: string
  coords: {
    lat: number
    lng: number
  }
}

export interface ICompanyProviderCreateDTO {
  companyProviderTaxId: string
  companyProviderEmail: string
  companyClientTaxId: string
}

export interface ICompanyProfile {
  assets?: ICompanyProfileAsssetsDTO
  documents?: ICompanyProfileDocumentsResponse[]
}

export enum IFarmNationalRegistryStatus {
  REGISTERED = 'registered',
  ACTIVE = 'active',
  PENDING = 'pending',
  CANCELED = 'canceled',
}
export interface ICompanyFarmData {
  ownerName: string
  nationalRegistry?: string
  nationalRegistryStatus?: IFarmNationalRegistryStatus
  geometry?: any
}

export type ICompanyResponse = ICompany &
  ICompanyProfile & {
    farmData?: ICompanyFarmData
  }

export interface ICompanyProfileAsssetsDTO {
  logo: string
}

export interface ICompanyProfileDocumentsResponse
  extends ICompanyProfileDocumentsCreate {
  extension: string
}

export interface ICompanyProfileDocumentsCreate {
  name: string
  file: File
  expiration?: string
  category?: string
}
export interface ICompanyProfileDocuments {
  id: string
  deletedAt: string
  createdAt: string
  updatedAt: string
  name: string
  file: string
  extension: string
  expiration: string
  category: string
  type: string
  companyId: string
}

export interface ICompanySegmentAlias {
  name: string
  color: string
  translate: string
  canHavePendingInvoice: boolean
  order: number
  supplyChains: string[]
}

/**
 * @description Has each prop from {@link CompanySegment}
 *              Can be implemented
 */
export type CompanySegmentType = {
  [key in CompanySegment]: ICompanySegmentAlias
}

export interface ICompanyRanking {
  taxId: string
  name: string
  totalItems: string
  percentageItems: string
}

export interface IProviderDashboard {
  pendingInvoicesQuantitySum: IStatisticsDTO
  pendingInvoicesPercentage: IStatisticsDTO
  completeInvoicesQuantitySum: IStatisticsDTO
  completeInvoicesPercentage: IStatisticsDTO
  invoicesQuantitySum: IStatisticsDTO
}

export interface GetProvidersAlltiersMap {
  type: 'cluster' | 'company'
  count: number
  data?: ICompany
  lat?: number
  lng?: number
}

export enum IIntegrationStatus {
  INTEGRATED = 'INTEGRATED',
  SENT_DECLARATION = 'SENT_DECLARATION',
  INACTIVE = 'INACTIVE',
}

export interface IRankedProviderDTO {
  id: string
  name: string
  taxId: string
  representation: number
  lastDeclarationFrom?: Date
  lastDeclarationTo?: Date
  tracedByDeclaration: number
  tracedByIntegrationWithoutDeclaration: number
  tracedByIntegrationWithDeclaration: number
  segment: CompanySegment
  integrationStatus: IIntegrationStatus
  declarationIsExpired: boolean
  socialEnvironmentalRisk: ISocialEnvironmentalRisk[]
}
